(function () {
  const STORAGE_KEY = 'ms_favorites';
  const selectors = {
    toggle: '[data-ms-wishlist-toggle]',
    count: '[data-ms-wishlist-count]',
    grid: '[data-ms-wishlist-grid]',
    empty: '[data-ms-wishlist-empty]',
    toast: '[data-ms-wishlist-toast]'
  };

  let toastTimer;

  const parseItems = () => {
    try {
      const stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(stored) ? stored : [];
    } catch (error) {
      return [];
    }
  };

  const compactItems = (items) => {
    const seen = new Set();

    return items
      .filter((item) => item && item.handle)
      .map((item) => ({
        handle: String(item.handle || ''),
        title: String(item.title || ''),
        url: String(item.url || ''),
        image: String(item.image || ''),
        price: String(item.price || ''),
        vendor: String(item.vendor || '')
      }))
      .filter((item) => {
        if (seen.has(item.handle)) return false;
        seen.add(item.handle);
        return true;
      });
  };

  const read = () => compactItems(parseItems());

  const write = (items) => {
    const favorites = compactItems(items);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(favorites));
    return favorites;
  };

  const normalize = (button) => ({
    handle: button.dataset.productHandle || '',
    title: button.dataset.productTitle || '',
    image: button.dataset.productImage || '',
    price: button.dataset.productPrice || '',
    url: button.dataset.productUrl || '',
    vendor: button.dataset.productVendor || ''
  });

  const escapeHtml = (value) =>
    String(value || '').replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    })[char]);

  const isFootwear = (item) => {
    const vendor = String(item.vendor || '').toLowerCase();
    const handle = String(item.handle || '').toLowerCase();
    return (
      ['fly london', 'softinos', 'as portuguesas', 'fred & frederico'].includes(vendor) ||
      ['shoe', 'boot', 'sandal', 'sneaker', 'sapato', 'bota', 'sandalia', 'sapatilha'].some((term) =>
        handle.includes(term)
      )
    );
  };

  const updateToggle = (button, active) => {
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', active ? 'Remover dos favoritos' : 'Adicionar aos favoritos');

    const label = button.querySelector('[data-ms-wishlist-label]');
    if (label) label.textContent = active ? 'Guardado nos favoritos' : 'Guardar nos favoritos';
  };

  const renderPage = (favorites) => {
    const grid = document.querySelector(selectors.grid);
    const empty = document.querySelector(selectors.empty);
    if (!grid || !empty) return;

    empty.hidden = favorites.length !== 0;
    grid.hidden = favorites.length === 0;

    grid.innerHTML = favorites.map((item) => `
      <article class="ms-wishlist-item" data-ms-wishlist-item="${escapeHtml(item.handle)}">
        <div class="ms-wishlist-item__media">
          <a class="ms-wishlist-item__media-link" href="${escapeHtml(item.url)}">
            ${item.image ? `<img class="ms-wishlist-item__image" src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy">` : ''}
          </a>
        </div>
        <div
          class="ms-card-quick-buy"
          data-ms-card-quick-buy
          data-product-handle="${escapeHtml(item.handle)}"
          data-ms-footwear="${isFootwear(item)}"
          data-ms-ready="false"
        >
          <button type="button" class="ms-card-quick-buy__title" data-ms-card-quick-buy-toggle aria-expanded="false">Escolher tamanho</button>
          <div class="ms-card-quick-buy__sizes" data-ms-card-quick-buy-sizes aria-label="Tamanhos disponíveis"></div>
          <p class="ms-card-quick-buy__status" data-ms-card-quick-buy-status role="status"></p>
        </div>
        <a class="ms-wishlist-item__content-link" href="${escapeHtml(item.url)}">
          <div class="ms-wishlist-item__content">
            ${item.vendor ? `<span class="ms-wishlist-item__vendor">${escapeHtml(item.vendor)}</span>` : ''}
            <h2 class="ms-wishlist-item__title">${escapeHtml(item.title)}</h2>
            ${item.price ? `<span class="ms-wishlist-item__price">${escapeHtml(item.price)}</span>` : ''}
          </div>
        </a>
        <button type="button" class="ms-wishlist-item__remove" data-ms-wishlist-remove="${escapeHtml(item.handle)}" aria-label="Remover dos favoritos">
          <svg viewBox="0 0 24 24" focusable="false" role="presentation" aria-hidden="true">
            <path d="M20.8 4.7a5.3 5.3 0 0 0-7.5 0L12 6l-1.3-1.3a5.3 5.3 0 0 0-7.5 7.5L12 21l8.8-8.8a5.3 5.3 0 0 0 0-7.5Z"/>
          </svg>
        </button>
      </article>
    `).join('');

    if (window.msHydrateQuickBuy) window.msHydrateQuickBuy(grid);
  };

  const ensureToast = () => {
    let toast = document.querySelector(selectors.toast);
    if (toast) return toast;

    toast = document.createElement('div');
    toast.className = 'ms-wishlist-toast';
    toast.dataset.msWishlistToast = '';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    document.body.appendChild(toast);

    return toast;
  };

  const showToast = (message) => {
    const toast = ensureToast();
    toast.textContent = message;
    toast.classList.add('is-visible');

    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => {
      toast.classList.remove('is-visible');
    }, 2000);
  };

  const updateAll = () => {
    const favorites = read();
    const handles = new Set(favorites.map((item) => item.handle));

    document.querySelectorAll(selectors.toggle).forEach((button) => {
      updateToggle(button, handles.has(button.dataset.productHandle));
    });

    document.querySelectorAll(selectors.count).forEach((count) => {
      const value = count.querySelector('[data-ms-wishlist-count-value]');
      const text = count.querySelector('[data-ms-wishlist-count-text]');

      if (value) {
        value.textContent = String(favorites.length);
      } else {
        count.textContent = String(favorites.length);
      }

      if (text) text.textContent = `${favorites.length} favoritos`;
      count.hidden = favorites.length === 0;
    });

    renderPage(favorites);
  };

  const toggle = (button) => {
    const product = normalize(button);
    if (!product.handle) return;

    const favorites = read();
    const exists = favorites.some((item) => item.handle === product.handle);
    const nextFavorites = exists
      ? favorites.filter((item) => item.handle !== product.handle)
      : [product, ...favorites];

    write(nextFavorites);
    button.classList.add('is-animating');
    window.setTimeout(() => button.classList.remove('is-animating'), 180);
    showToast(exists ? 'Removido dos favoritos' : 'Adicionado aos favoritos \u2665');
    updateAll();
  };

  document.addEventListener('click', (event) => {
    const toggleButton = event.target.closest(selectors.toggle);
    if (toggleButton) {
      event.preventDefault();
      event.stopPropagation();
      toggle(toggleButton);
      return;
    }

    const removeButton = event.target.closest('[data-ms-wishlist-remove]');
    if (removeButton) {
      const handle = removeButton.dataset.msWishlistRemove;
      write(read().filter((item) => item.handle !== handle));
      showToast('Removido dos favoritos');
      updateAll();
    }
  });

  document.addEventListener('DOMContentLoaded', updateAll);
  document.addEventListener('shopify:section:load', updateAll);
  window.addEventListener('pageshow', updateAll);
})();
